(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  (function () {
    var HOLD_MS = 4200;
    var FADE_MS = 280;

    function initBar(bar) {
      if (!bar) return;
      if (typeof bar._announcementCleanup === 'function') {
        bar._announcementCleanup();
      }

      var messages = Array.prototype.slice.call(bar.querySelectorAll('.announcement-bar__message'));
      if (messages.length < 2) return;

      var current = 0;
      var timer = null;
      var fadeTimer = null;
      var busy = false;
      var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function showOnly(index) {
        if (fadeTimer) {
          window.clearTimeout(fadeTimer);
          fadeTimer = null;
        }
        messages.forEach(function (el, i) {
          el.classList.remove('is-active', 'is-exit');
          if (i === index) {
            el.removeAttribute('hidden');
            el.classList.add('is-active');
          } else {
            el.setAttribute('hidden', '');
          }
        });
        current = index;
        busy = false;
      }

      showOnly(0);

      function goNext() {
        if (busy || document.hidden) return;

        var next = (current + 1) % messages.length;
        var outgoing = messages[current];
        var incoming = messages[next];

        if (reduced) {
          showOnly(next);
          return;
        }

        busy = true;
        outgoing.classList.remove('is-active');
        outgoing.classList.add('is-exit');

        fadeTimer = window.setTimeout(function () {
          fadeTimer = null;
          outgoing.classList.remove('is-exit');
          outgoing.setAttribute('hidden', '');
          incoming.removeAttribute('hidden');
          incoming.classList.add('is-active');
          current = next;
          busy = false;
        }, FADE_MS);
      }

      function start() {
        if (timer) window.clearInterval(timer);
        timer = window.setInterval(goNext, HOLD_MS);
      }

      function stop() {
        if (timer) window.clearInterval(timer);
        timer = null;
        if (fadeTimer) {
          window.clearTimeout(fadeTimer);
          fadeTimer = null;
        }
      }

      function onVis() {
        if (document.hidden) {
          stop();
          showOnly(current);
        } else {
          showOnly(current);
          start();
        }
      }

      document.addEventListener('visibilitychange', onVis);
      bar._announcementCleanup = function () {
        document.removeEventListener('visibilitychange', onVis);
        stop();
      };

      start();
    }

    function initAll() {
      document.querySelectorAll('[data-announcement-bar]').forEach(initBar);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      var bar = event.target.querySelector('[data-announcement-bar]');
      if (bar) initBar(bar);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fabpad-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initHero() {
      var heroSection = document.querySelector('[data-fabpad-hero]');
      if (!heroSection || heroSection.dataset.heroInit === 'true') return;
      heroSection.dataset.heroInit = 'true';

      var slideshow = heroSection.querySelector('[data-hero-slideshow]');
      var track = heroSection.querySelector('[data-hero-track]');
      var slides = heroSection.querySelectorAll('[data-hero-slide]');
      var dots = heroSection.querySelectorAll('[data-hero-dot]');
      var firstImg = heroSection.querySelector('[data-hero-first-img]');
      var scrollHint = document.querySelector('[data-hero-scroll-hint]');
      var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      var currentSlide = 0;
      var touchStartX = 0;
      var autoplayTimer = null;
      var AUTOPLAY_MS = 4000;
      var MANUAL_HOLD_MS = 5000;

      if (scrollHint) {
        window.addEventListener('scroll', function () {
          scrollHint.classList.toggle('is-hidden', window.scrollY > 100);
        }, { passive: true });
      }

      function markReady() {
        if (slideshow) slideshow.classList.add('is-ready');
      }

      if (firstImg) {
        if (firstImg.complete && firstImg.naturalWidth > 0) {
          markReady();
        } else {
          firstImg.addEventListener('load', markReady);
          firstImg.addEventListener('error', markReady);
        }
      } else {
        markReady();
      }

      function goToSlide(index, wrap) {
        if (!track || !slides.length) return;
        if (wrap) {
          currentSlide = ((index % slides.length) + slides.length) % slides.length;
        } else {
          currentSlide = Math.max(0, Math.min(index, slides.length - 1));
        }
        track.style.transform = 'translateX(-' + currentSlide * 100 + '%)';
        slides.forEach(function (slide, i) {
          slide.classList.toggle('is-active', i === currentSlide);
        });
        dots.forEach(function (dot, i) {
          var active = i === currentSlide;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-selected', active ? 'true' : 'false');
        });
      }

      function stopAutoplay() {
        if (autoplayTimer) {
          window.clearTimeout(autoplayTimer);
          autoplayTimer = null;
        }
      }

      function startAutoplay(holdMs) {
        stopAutoplay();
        if (prefersReducedMotion.matches || slides.length < 2) return;
        var delay = typeof holdMs === 'number' ? holdMs : AUTOPLAY_MS;
        autoplayTimer = window.setTimeout(function tick() {
          goToSlide(currentSlide + 1, true);
          autoplayTimer = window.setTimeout(tick, AUTOPLAY_MS);
        }, delay);
      }

      function hydrateLazySlides() {
        if (heroSection.dataset.heroLazyLoaded === 'true') return;
        heroSection.dataset.heroLazyLoaded = 'true';
        heroSection.querySelectorAll('[data-hero-lazy]').forEach(function (el) {
          var srcset = el.getAttribute('data-srcset');
          var src = el.getAttribute('data-src');
          if (srcset) el.setAttribute('srcset', srcset);
          if (src) el.setAttribute('src', src);
        });
      }

      function loadLazyThenAutoplay() {
        hydrateLazySlides();
        startAutoplay();
      }

      function scheduleLazyAutoplay() {
        window.setTimeout(loadLazyThenAutoplay, 1500);
      }

      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          hydrateLazySlides();
          goToSlide(parseInt(dot.dataset.heroDot, 10));
          startAutoplay(MANUAL_HOLD_MS);
        });
      });

      if (slideshow && track) {
        slideshow.addEventListener('touchstart', function (e) {
          touchStartX = e.changedTouches[0].screenX;
        }, { passive: true });

        slideshow.addEventListener('touchend', function (e) {
          var delta = e.changedTouches[0].screenX - touchStartX;
          if (Math.abs(delta) < 40) return;
          hydrateLazySlides();
          goToSlide(delta < 0 ? currentSlide + 1 : currentSlide - 1, true);
          startAutoplay(MANUAL_HOLD_MS);
        }, { passive: true });
      }

      goToSlide(0);

      if (document.readyState === 'complete') {
        scheduleLazyAutoplay();
      } else {
        window.addEventListener('load', scheduleLazyAutoplay, { once: true });
      }

      document.addEventListener('visibilitychange', function () {
        if (document.hidden) stopAutoplay();
        else {
          hydrateLazySlides();
          startAutoplay();
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initHero);
    } else {
      initHero();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fabpad-padma-band"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var graphic = document.querySelector('[data-padma-graphic]');
    if (!graphic) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      graphic.classList.add('is-static');
      return;
    }

    var played = false;
    var armed = false;

    function armPlayback() {
      armed = true;
    }

    function playGraphic() {
      if (played) return;
      played = true;
      graphic.classList.add('is-playing');
      if (observer) observer.disconnect();
    }

    var viewHeight = window.innerHeight || document.documentElement.clientHeight;
    if (graphic.getBoundingClientRect().top > viewHeight * 0.85) {
      armPlayback();
    }

    window.addEventListener(
      'scroll',
      function onScroll() {
        armPlayback();
        window.removeEventListener('scroll', onScroll);
      },
      { passive: true }
    );

    var observer = null;

    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!armed || played || !entry.isIntersecting) return;
            if (entry.intersectionRatio < 0.2) return;
            playGraphic();
          });
        },
        { threshold: [0, 0.2, 0.35], rootMargin: '0px 0px -8% 0px' }
      );

      observer.observe(graphic);
    } else {
      armPlayback();
      playGraphic();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
